import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class PlanProizvodnjeService {
  constructor(private _http: HttpClient) {}

  dohvatiPlanProizvodnje(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'planproizvodnje_prikaz', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLinije(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  pregledSmjene(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_podatke_na_liniji', a)
      .pipe(map((res: any) => res));
  }
}
